module.exports = __webpack_public_path__ + "media/images/realizacje/real3-115c958ceff5862d3010ca28539f806b.png";